import { useCallback, useMemo, useState } from 'react'
import useLocalStorage from './useLocalStorage'
import { OverlayState } from './useOverlay'

export type UseOverlayOptions = {
  initiallyOpen?: boolean
  localStorageKey: string
}

export default function useOverlayLocalStorage({
  initiallyOpen = false,
  localStorageKey,
}: UseOverlayOptions): OverlayState {
  const [isOpenLS, setIsOpenLS] = useLocalStorage(
    localStorageKey,
    initiallyOpen,
  )

  const [anchorEl, setAnchorEl] = useState<EventTarget | null>(null)

  const close = useCallback(() => {
    setIsOpenLS(false)
  }, [setIsOpenLS])

  const open = useCallback(
    (event?: React.UIEvent | MouseEvent | TouchEvent) => {
      if (event) setAnchorEl(event.target)
      setIsOpenLS(true)
    },
    [setIsOpenLS],
  )

  const toggle = useCallback(
    (event?: React.UIEvent | MouseEvent | TouchEvent) => {
      if (event) setAnchorEl(event.target)

      setIsOpenLS((prev) => !prev)
    },
    [setIsOpenLS],
  )

  return useMemo(
    () => ({
      isOpen: isOpenLS,
      close,
      open,
      toggle,
      anchorEl,
    }),
    [anchorEl, close, isOpenLS, open, toggle],
  )
}
